export const ApiUrls = {
  PAGE_SHELL: "/pageShell",
  PAGES_HEADER: "/pages/header",
  PRODUCTS: "/pages/products",
  STORES: "/stores",
  BUNDLES: "/pages/bundles",
  OTT: "/pages/mock/bundle-ott",
  FETCH_CONTRACTS: "/pages/contracts",
  ORDER_SUBMIT: "/checkout/order",
  FETCH_MANHATTAN_ORDER: "/checkout/order",
  FETCH_TRANSACTION: "/checkout/transaction",
  CANCEL_TRANSACTION: "/checkout/order/cancel",
  EDIT_STEP: "/checkout/step",
  VERIFICATION_SMS: "/verification/sms",
  CAMPAIGNS: "/campaigns",
  CAMPAIGNS_HELP: "/campaigns/call-me",
  WISH_LIST: "/wishlist",
  PAK: {
    GET_CITIES: '/pak/municipality/city',
    GET_NEIGHBORHOODS: '/pak/municipality',
  },
  USER: {
    LOGIN: '/user/login',
    LOGOUT: '/user/logout',
    SSO: '/user/sso',
    SSO_EXAMPLE: '/user/sso-example',
  },
  PREPAID_REGISTRATION: '/prepaid-registration',
  PRODUCT_INSURANCE: '/additional/insurance',
  PRODUCT_SUGGESTIONS: '/suggestions',
  SEND_ORDER_TO_EMAIL: '/checkout/basket',
  APPLY_VOUCHER: '/voucher/apply',
  VERIFICATION_GREEN_VOUCHER: '/verification/green-voucher',
  CHANGE_DEVICE_COLOR: '/checkout/change/color',
  ORDER_ITEM: '/checkout/order/item',
  VERIFICATION_VOUCHER: '/verification/voucher',
  VERIFICATION_ACCESSORY_VOUCHER: '/verification/acc-voucher',
  TOPUP: '/topup',
  MAINTENANCE_MODE: '/maintenance-mode',
  DEBUG: '/info',
};

export default ApiUrls;
